import styled from "styled-components";

export const RetryScreenIconDefaultBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5rem;
    height: 5rem;
    background: ${({theme}) => theme.colors.bodyBackground.toString()};
    border-radius: 50%;
`;
